import AOS from 'aos'; //Dos: https://github.com/michalsnik/aos

/**
 * Add the applicable 'data-aos-*' attributes to the target element prior to initializing the AOS script
 *
 * @param {HTMlElement} el - The element to be animated
 * @param {Object} settings - Animation settings
 * @param {int} index - the current index of the element
 * @param {bool} staggerStart - If true the delay will be calculated based upon the supplied value * index
 */
function addAnimationAttrib(el, settings, index = 0, staggerStart = false) {
    for (const key in settings) {
        if (settings.hasOwnProperty(key)) {
            let attrib = `data-aos-${key}`;
            let value = settings[key];

            switch (key) {
                case 'type':
                    attrib = 'data-aos';
                    break;
                case 'delay':
                    if (staggerStart) {
                        value = settings[key] * index;
                    }
                    break;
            }
            el.setAttribute(attrib, value);
        }
    }
}

/**
 * Initialize Animations only if settings are supplied.  Sets any default values to the body tag.
 * Loops thru the supplied elements to be animated and set animation props.
 */
export function initAnimation() {
    const animationSettings = window.dssMlpConfigs.animationSettings;

    if (!animationSettings || !animationSettings.settings) return;
    const { settings } = animationSettings;

    if (settings.default) {
        addAnimationAttrib(document.body, settings.default);
    }

    if (settings.elements) {
        settings.elements.forEach(value => {
            document.querySelectorAll(value.class).forEach((elm, index) => {
                addAnimationAttrib(elm, value.options, index, value.staggerStart);
            });
        });
    }
    AOS.init({ once: true });
}
